export const messageTheme = {
  transitionDuration: '0.2s',
  icon: {
    lg: {
      size: 'var(--two-rem)',
    },
    sm: {
      size: 'var(--one-rem)',
    },
    size: 'var(--one-half-rem)',
  },
  closeButton: {
    width: 'var(--two-rem)',
    height: 'var(--two-rem)',
    borderRadius: 'var(--pct-50)',
    focusRing: {
      offset: 'var(--reset)',
    },
  },
  extend: {
    agility: {
      fontSize: 'var(--font-size-sm)',
    },
  },
  colorScheme: {
    light: {
      info: {
        background: 'var(--p-primary-100)',
        color: 'var(--primary-color)',
        shadow: 'var(--reset)',
        borderColor: 'var(--primary-color)',
      },
      success: {
        background: 'var(--p-success-0)',
        color: 'var(--p-success-500)',
        shadow: 'var(--reset)',
        borderColor: 'var(--p-success-500)',
      },
      warn: {
        background: 'var(--p-warning-0)',
        color: 'var(--p-warning-500)',
        shadow: 'var(--reset)',
        borderColor: 'var(--p-warning-500)',
      },
      error: {
        background: 'var(--p-danger-0)',
        color: 'var(--p-danger-500)',
        shadow: 'var(--reset)',
        borderColor: 'var(--p-danger-500)',
      },
    },
    dark: {
      info: {
        background: 'var(--p-primary-900)',
        color: 'var(--primary-color)',
        shadow: 'var(--reset)',
        borderColor: 'var(--primary-color)',
      },
      success: {
        background: 'var(--p-success-900)',
        color: 'var(--p-success-500)',
        shadow: 'var(--reset)',
        borderColor: 'var(--p-success-500)',
      },
      warn: {
        background: 'var(--p-warning-900)',
        color: 'var(--p-warning-500)',
        shadow: 'var(--reset)',
        borderColor: 'var(--p-warning-500)',
      },
      error: {
        background: 'var(--p-danger-900)',
        color: 'var(--p-danger-500)',
        shadow: 'var(--reset)',
        borderColor: 'var(--p-danger-500)',
      },
    },
  },
  root: {
    borderRadius: 'var(--border-radius)',
  },
};
